import useDocumentStore from "@/stores/document";
import useAuthStore from "@/stores/auth";

const fileVisibilityMiddleware = async ({ to, next }) => {
    const fileId = to.params.id;
    const detailFile = await useDocumentStore().getDetailData(fileId);
    let expiredAt = useAuthStore().user.expired;
    const now = Date.now();
    let isTokenValid = false;

    if (expiredAt) {
        const expiry = typeof expiredAt === "string" ? new Date(expiredAt).getTime() : expiredAt;
        isTokenValid = expiry > now;
    }
    if (detailFile.visibility == "PRIVATE" && !isTokenValid) {
        return next({ name: "login", query: { redirect: to.fullPath } });
    }
    return next();
};

export default fileVisibilityMiddleware;